import React from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { Styles } from "./styles/tabBox.js";
import useSiteContent from "../hooks/useSiteContent";

const TabBox = () => {
  const { tabs = [] } = useSiteContent("about");

  if (tabs.length === 0) return null;

  return (
    <Styles>
      {/* Tab Box Area */}
      <section className="tab-section">
        <Container>
          <Tab.Container defaultActiveKey={tabs[0].key}>
            <Row>
              <Col lg="3" md="4">
                <Nav className="flex-column">
                  {tabs.map((tab) => (
                    <Nav.Item key={tab.key}>
                      <Nav.Link eventKey={tab.key}>
                        <i className="las la-arrow-right"></i> {tab.title}
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </Col>
              <Col lg="9" md="8">
                <Tab.Content>
                  {tabs.map((tab) => (
                    <Tab.Pane eventKey={tab.key} key={tab.key}>
                      <h4 className="tab-title">{tab.title}</h4>
                      <p className="tab-desc">{tab.desc}</p>
                      <ul className="list-unstyled check-list">
                        {(tab.points || []).map((point, i) => (
                          <li key={i}>
                            <i className="fa fa-check"></i> {point}
                          </li>
                        ))}
                      </ul>
                    </Tab.Pane>
                  ))}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Container>
      </section>
    </Styles>
  );
};

export default TabBox;
